<template>
  <el-menu-item :index="(menu.name || uniqueId).toLowerCase()">
    <i v-if="menu.icon" :class="`fa ${menu.icon}`"></i>
    <i v-if="menu.icon === undefined & !menu.iconSvg" class="fa fa-file-o"></i>
    <d2-icon-svg v-if="menu.iconSvg" :name="menu.iconSvg"/>
    <span slot="title" class="title">{{ $t(`menus.${menu.name}`) || '未命名菜单' }}</span>
  </el-menu-item>
</template>

<script>
import { uniqueId } from 'lodash'
export default {
  name: 'd2-layout-header-aside-menu-item',
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      uniqueId: uniqueId('d2-menu-empty-')
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/components/menu-item/index.vue"
}
</vue-filename-injector>
